module.exports = __webpack_public_path__ + "static/img/ilustra_verso_cnh.22b0fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_verso_cnh.png
// module id = dVjB
// module chunks = 2